import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

import { useFieldErrors } from '../../useFieldErrors';

const ErrorField = ({ additionalClasses, testId }) => {
  const errors = useFieldErrors();

  return (
    <div
      className={twMerge('text-sm text-red', additionalClasses)}
      {...getTestProps(testId)}
    >
      {errors}
    </div>
  );
};

export default ErrorField;
